import React from "react";
import Heading from "../Heading";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { sxClassName, sxProps } from "../props/sx";
import { spacingClassName, spacingProps } from "../props/spacing";

const SimpleTemplateTitle = ({
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	className = "",
	size = "xl",
	children,
	...props
}) => {
	return (
		<Heading
			Tag="h1"
			className={classes(
				...sxClassName(
					deepMergeProps({ fontSize: size, textAlign: "center" }, pureProps(sx)),
					true,
				),
				...spacingClassName(deepMergeProps({ mb: 6 }, pureProps(spacing))),
				className,
			)}
			{...props}
		>
			{children}
		</Heading>
	);
};

SimpleTemplateTitle.propTypes = {
	...Heading.propTypes,
};

export default SimpleTemplateTitle;
